import React from 'react';

const SunIcon = ({ size, color = "currentColor", ...props }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M10.0002 15.4166C12.9917 15.4166 15.4168 12.9915 15.4168 9.99998C15.4168 7.00844 12.9917 4.58331 10.0002 4.58331C7.00862 4.58331 4.5835 7.00844 4.5835 9.99998C4.5835 12.9915 7.00862 15.4166 10.0002 15.4166Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.9498 15.95L15.8415 15.8417M15.8415 4.15835L15.9498 4.05002L15.8415 4.15835ZM4.04984 15.95L4.15817 15.8417L4.04984 15.95ZM9.99984 1.73335V1.66669V1.73335ZM9.99984 18.3334V18.2667V18.3334ZM1.73317 10H1.6665H1.73317ZM18.3332 10H18.2665H18.3332ZM4.15817 4.15835L4.04984 4.05002L4.15817 4.15835Z" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);

SunIcon.defaultProps = {
  size: 14,
};
export default SunIcon;
